import {Page, Pages, PracticeData} from "@/libwyze-shared/types";
import {StringUtil} from "@/shared/string_util";
import {getMemberAuth} from "@/shared/auth";
import {MESSAGING_TEMPLATE_KTM, MessagingSendChannel, MessagingTemplateId} from "@/libwyze-common/api/types";
import {BaseWhatsAppCampaignFragment, WhatsApp} from "./BaseWhatsAppCampaignFragment";
import React, {ReactElement} from "react";
import {MessageCampaignConfig, MessageCampaignConfigType} from "../BaseMessageCampaignFragment";
import {
  BirthdayWhatsAppCampaignCustomizeOptions,
  BirthdayWhatsAppCampaignTemplate
} from "@/vantage-shared/types";
import {$KTS} from "@/shared/keytext";
import {Typography} from "@mui/material";

export class BirthdayWhatsAppCampaignFragment extends BaseWhatsAppCampaignFragment<BirthdayWhatsAppCampaignCustomizeOptions> {

  private readonly memberAuth = getMemberAuth();

  protected createCampaignConfig(): MessageCampaignConfig {
    return {
      name: "Birthday",
      type: MessageCampaignConfigType.MESSAGING,
      messaging: {
        channel: MessagingSendChannel.WHATSAPP,
        title: "Send birthday WhatsApp",
        text: "Send personalized birthday WhatsApp messages to your patients. Make your patients feel good on their special day. Simply configure the kind of message you would like to send from our collection of templates, and we'll automatically send it out at the right time.",
        templateVariables: [
          Pages.getInstance().getListItem(PracticeData.provider().practiceId).practicePageProfile.basicInfo.name,
          this.memberAuth.member.user.firstname,
        ],
        templateId: MessagingTemplateId.PATIENT_BIRTHDAY_GREETING,
      }
    };
  }

  protected async fetchOnMount(forceReload?: boolean): Promise<any> {
    await super.fetchOnMount(forceReload);
    this.setState({
      customizeOptions: await BirthdayWhatsAppCampaignCustomizeOptions.load(PracticeData.shared().practiceId),
    });
  }

  private replaceWhatsAppTemplatePlaceholders(whatsAppText: string, template: BirthdayWhatsAppCampaignTemplate, practiceName: string): WhatsApp {
    return {
      body: StringUtil.replacePlaceholders(whatsAppText, ...this.campaignConfig.messaging.templateVariables.map((str, index) => $KTS(`${index + 1}`, str))),
    }
  }

  private whatsAppText: string;

  protected async generateMessage(practicePage: Page): Promise<WhatsApp> {
    if (!this.whatsAppText) {
      this.whatsAppText = MESSAGING_TEMPLATE_KTM.findMetadata(this.campaignConfig.messaging.templateId).templateText;
    }
    return this.replaceWhatsAppTemplatePlaceholders(this.whatsAppText, this.state.customizeOptions.template, practicePage.practicePageProfile.basicInfo.name);
  }

  protected renderPreview(whatsApp: WhatsApp): ReactElement {
    return <Typography>{whatsApp.body}</Typography>
  }
}